/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const fireExplosionEnumsSubCategoryEnum = {
    Fire: 'Fire',
    Explosion: 'Explosion',
    CombinationOfAbove: 'CombinationOfAbove',
    Other: 'Other',
} as const;

export type FireExplosionEnumsSubCategoryEnumKey =
    (typeof fireExplosionEnumsSubCategoryEnum)[keyof typeof fireExplosionEnumsSubCategoryEnum];

export type FireExplosionEnumsSubCategory = FireExplosionEnumsSubCategoryEnumKey;
